import React, { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TablePagination,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  CustomMenu,
  CustomMenuItem,
  StyledTableRow,
} from "../../../../styles/Shipmentstyles";
import { Stock } from "../../../../models/Stock/Stock";
import AppTableHeaderCell from "../../common/pages/AppTableHeaderCell";
import AppTableRowCell from "../../common/pages/AppTableRowCell";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../common/functions/formatDate";

interface StockTableProp {
  stocks: Stock[];
  orderDirection: string | undefined;
  // onSortChange: (column: string) => void;
  orderBy: string | undefined;
  page_no: number;
  total_count: number;
  total_pages: number;
  limit: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  onRowsPerPageChange: (limit: number) => void;
}

const StockTable = ({
  stocks,
  orderDirection,
  // onSortChange,
  orderBy,
  page_no,
  limit,
  total_count,
  total_pages,
  onPageChange,
  onRowsPerPageChange,
}: StockTableProp) => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedStockId, setSelectedStockId] = useState<number>();

  const isOpen = Boolean(anchorEl);

  const handleMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    stockId: number
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedStockId(stockId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedStockId(undefined);
  };

  const handleView = () => {
    if (selectedStockId) {
      const stock = stocks.find((s) => s.id === selectedStockId);
      if (stock) {
        let orderURL = `/orders/add-orders?orderId=${stock.order_id}`;
        window.open(orderURL, "_blank");
      }
    }
    handleMenuClose();
  };

  // const handleRequestSort = (property: string) => {
  //   onSortChange(property);
  // };

  const changeMinutesIntoHoursAndMins = (inputInt: number) => {
    if (inputInt > 0) {
      const hours = Math.trunc(inputInt / 60);
      const mins = Math.trunc(inputInt % 60);

      if (mins === 0) {
        return "--";
      } else if (hours === 0) {
        return `${mins} min`;
      } else {
        return `${hours} hr ${mins} min`;
      }
    } else {
      return "-";
    }
  };

  const handleRowsChange = (value: number) => {
    onPageChange(null, 1);
    onRowsPerPageChange(value);
  };

  return (
    <>
      <Paper sx={{ marginTop: "0.6rem" }}>
        <TableContainer sx={{ maxHeight: window.innerHeight - 220 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <AppTableHeaderCell
                  title="S.No"
                  sx={{
                    textAlign: "center",
                  }}
                />
                <AppTableHeaderCell sx={{ textAlign: "center" }}>
                  ID
                </AppTableHeaderCell>
                <AppTableHeaderCell sx={{ textAlign: "center" }}>
                  Order ID
                </AppTableHeaderCell>
                <AppTableHeaderCell sx={{ textAlign: "center" }}>
                  Order Label
                </AppTableHeaderCell>
                <AppTableHeaderCell sx={{ textAlign: "center" }}>
                  Order Type
                </AppTableHeaderCell>
                <AppTableHeaderCell sx={{ textAlign: "center" }}>
                  Requestor Name
                </AppTableHeaderCell>
                <AppTableHeaderCell sx={{ textAlign: "center" }}>
                  Status
                </AppTableHeaderCell>
                <AppTableHeaderCell sx={{ textAlign: "center" }}>
                  Tat
                </AppTableHeaderCell>
                <AppTableHeaderCell sx={{ textAlign: "center" }}>
                  Notes
                </AppTableHeaderCell>

                <AppTableHeaderCell sx={{ textAlign: "center" }}>
                  Modified Date
                </AppTableHeaderCell>
                <AppTableHeaderCell sx={{ textAlign: "center" }}>
                  Closer Name
                </AppTableHeaderCell>
                {/* </TableSortLabel> */}
                <AppTableHeaderCell sx={{ textAlign: "center" }}>
                  Action
                </AppTableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {stocks.map((stock: Stock, index) => (
                <StyledTableRow key={stock.id}>
                  <AppTableRowCell
                    sx={{
                      fontWeight: 700,
                    }}
                  >
                    {(page_no - 1) * limit + index + 1}
                  </AppTableRowCell>
                  <AppTableRowCell sx={{ textAlign: "center" }}>
                    {stock.id}
                  </AppTableRowCell>
                  <AppTableRowCell
                    sx={{
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() =>
                      navigate(`/orders/add-orders?orderId=${stock.order_id}`)
                    }
                  >
                    {stock.order_id}
                  </AppTableRowCell>
                  <AppTableRowCell sx={{ textAlign: "center" }}>
                    {stock.order_label || "NA"}
                  </AppTableRowCell>
                  <AppTableRowCell sx={{ textAlign: "center" }}>
                    {stock.order_type || "NA"}
                  </AppTableRowCell>
                  <AppTableRowCell sx={{ textAlign: "center" }}>
                    {stock.requestor_name || "NA"}
                  </AppTableRowCell>
                  <AppTableRowCell sx={{ textAlign: "center" }}>
                    {stock.status_label}
                  </AppTableRowCell>
                  <AppTableRowCell sx={{ textAlign: "center" }}>
                    {" "}
                    {stock.tat
                      ? changeMinutesIntoHoursAndMins(Number(stock.tat))
                      : "NA"}
                  </AppTableRowCell>
                  <AppTableRowCell sx={{ textAlign: "center" }}>
                    {stock.notes || "NA"}
                  </AppTableRowCell>
                  <AppTableRowCell sx={{ textAlign: "center" }}>
                    {stock.modified_date
                      ? formatDate(stock.modified_date)
                      : "--"}
                  </AppTableRowCell>
                  <AppTableRowCell sx={{ textAlign: "center" }}>
                    {stock.closer_name || "NA"}
                  </AppTableRowCell>
                  <AppTableRowCell sx={{ textAlign: "center" }}>
                    <IconButton
                      onClick={(event) => {
                        handleMenuClick(event, Number(stock.id));
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <CustomMenu
                      anchorEl={anchorEl}
                      open={isOpen}
                      onClose={handleMenuClose}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <CustomMenuItem onClick={handleView}>View</CustomMenuItem>
                    </CustomMenu>
                  </AppTableRowCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {total_count > 0 && (
          <TablePagination
            count={total_count}
            rowsPerPage={limit}
            page={page_no - 1}
            onPageChange={(event, page_no) => onPageChange(event, page_no + 1)}
            onRowsPerPageChange={(event) =>
              handleRowsChange(parseInt(event.target.value, 10))
            }
            rowsPerPageOptions={[30, 50, 100, 150, 200]}
            component="div"
          />
        )}
      </Paper>
    </>
  );
};

export default StockTable;
